/* LBC product card: colour swatch select + inline quick options */
(function () {
  'use strict';
  var d = document;
  function pick(c, s) {
    [].forEach.call(c.querySelectorAll('.sw'), function (b) { var on = b === s; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
    var add = c.querySelector('.c-add[data-lbc-add]');
    if (add) { add.setAttribute('data-lbc-add', s.getAttribute('data-id')); add.disabled = s.hasAttribute('data-out'); add.setAttribute('aria-label', (add.getAttribute('data-l') || '+') + ' – ' + s.getAttribute('aria-label')); }
    var pr = c.querySelector('[data-c-price]');
    if (pr) { var cmp = s.getAttribute('data-cmp'); pr.innerHTML = (cmp ? '<s>' + cmp + '</s>' : '') + s.getAttribute('data-price'); }
    var n = c.querySelector('[data-c-name]'); if (n) n.textContent = s.getAttribute('aria-label');
    var src = s.getAttribute('data-img');
    if (src) { var im = c.querySelector('.ph img:not(.alt)'); if (im) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = src; } }
  }
  d.addEventListener('click', function (e) {
    var s = e.target.closest('.lbc-card .sw');
    if (s) { e.preventDefault(); var c = s.closest('.lbc-card'); if (c) pick(c, s); return; }
    var t = e.target.closest('.lbc-card [data-c-toggle]');
    if (t) {
      e.preventDefault();
      var c2 = t.closest('.lbc-card'), o = c2 && c2.querySelector('.c-opts');
      var open = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', String(open)); if (o) o.hidden = !open;
      return;
    }
    var q = e.target.closest('.lbc-card .c-opts [data-lbc-add]');
    if (q) {
      var c3 = q.closest('.lbc-card'), tg = c3 && c3.querySelector('[data-c-toggle]'), o3 = c3 && c3.querySelector('.c-opts');
      setTimeout(function () { if (tg) tg.setAttribute('aria-expanded', 'false'); if (o3) o3.hidden = true; }, 450);
    }
  });
  d.addEventListener('keydown', function (e) {
    var s = e.target.closest && e.target.closest('.lbc-card .sw'); if (!s) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var all = [].slice.call(s.parentNode.querySelectorAll('.sw'));
    var i = all.indexOf(s) + (e.key === 'ArrowRight' ? 1 : -1);
    var n = all[(i + all.length) % all.length];
    e.preventDefault(); n.focus(); pick(n.closest('.lbc-card'), n);
  });
})();
